import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astcomputerscienceapplication',
  templateUrl: './astcomputerscienceapplication.component.html',
  styleUrls: ['./astcomputerscienceapplication.component.scss']
})
export class AstcomputerscienceapplicationComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
